<style lang="scss" scoped>
#postback-help-table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}
#postback-help-table > tr > td,
#postback-help-table > tr > th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}
#postback-help-table > tr:nth-child(even) {
  background-color: #dddddd;
}
textarea {
  min-height: 15rem;
}
</style>

<template>
  <section>
    <resource
      title="Ändern"
      resource="postback"
      resourceName="Postback Update"
      :original="original"
      :attributes="[
        {
          name: 'type',
          label: 'Type',
          type: 'DropdownSelector',
          items: typeOptions
        },
        {
          name: 'affiliate_id',
          label: 'Werbung-ID',
          type: 'DropdownSelector',
          items: affiliates
        },
        {
          name: 'postback',
          label: 'Postback (URL o. Script)',
          type: 'TextareaSelector'
        },
        {
          name: 'trigger_event',
          label: 'Event',
          type: 'DropdownSelector',
          items: triggerEventOptions
        }
      ]"
    >
      <div slot="title">
        <h4>Postback bearbeiten</h4>
      </div>
    </resource>

    <div class="card">
      <div class="card-header">
        <h4>Hinweis</h4>
      </div>
      <div class="card-body">
        <div class="form-group row">
          <br />
          <col-label>URL-Attribute</col-label>
          <div class="col-4">
            <table id="postback-help-table">
              <tr>
                <th class="col-2">Wert</th>
                <th class="col-1">Platzhalter</th>
              </tr>
              <tr>
                <td>User ID</td>
                <td>|uid|</td>
              </tr>
              <tr>
                <td>User Email-Adresse</td>
                <td>|email|</td>
              </tr>
              <tr>
                <td>User Extern-ID</td>
                <td>|eid|</td>
              </tr>
              <tr>
                <td>Geldbetrag (in € cent)</td>
                <td>|amount|</td>
              </tr>
              <tr>
                <td>Geldbetrag (in €)</td>
                <td>|amount_de|</td>
              </tr>
              <tr>
                <td>Geldbetrag (in $)</td>
                <td>|amount_us|</td>
              </tr>
              <tr>
                <td>Werbe ID</td>
                <td>|aid|</td>
              </tr>
              <tr>
                <td>Tracking-Code (der Kampagne)</td>
                <td>|code|</td>
              </tr>
              <tr>
                <td>Domain</td>
                <td>|domain|</td>
              </tr>
              <tr>
                <td>IP</td>
                <td>|ip|</td>
              </tr>
              <tr>
                <td>Zeitpunkt in Unixtime inkl. Millisekunde</td>
                <td>|microtime|</td>
              </tr>
              <tr>
                <td>Zeitpunkt Unixtime</td>
                <td>|time|</td>
              </tr>
              <tr>
                <td>Datum und Uhrzeit (<code>date('Y-m-d H:i:s')</code>)</td>
                <td>|datetime|</td>
              </tr>
              <tr>
                <td>
                  Datum und Uhrzeit deutsches Format (<code
                    >date('d.m.Y H:i:s')</code
                  >)
                </td>
                <td>|datetime_deu|</td>
              </tr>
              <tr>
                <td>Eineindeutige ID, benutzt <code>uniqid()</code></td>
                <td>|uuid|</td>
              </tr>
              <tr>
                <td>Zufallszahl zwischen 0 und 2147483647</td>
                <td>|rand|</td>
              </tr>
              <tr>
                <td>Rechnungsnummer, <b>nur</b> bei Event Kauf, sonst NULL</td>
                <td>|invoice_nr|</td>
              </tr>
              <tr>
                <td>Bei Registrierung zusätzlich übergebener Parameter</td>
                <td>|parameter['<i>VALUE</i>']|</td>
              </tr>
            </table>

            <br />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="babel">
import store from "@/store";

export default {
  beforeRouteEnter (to, from, next) {
    store.dispatch('postback/read', [
      {
        name: 'where',
        attributes: {
          id : [Number(to.params.id)],
        }
      },
    ]).then(() => {
      next();
    });
  },
  methods: {
    getAffiliates() {
      return this.$http
        .get("/api/v1/affiliate/postbackRead")
        .then(({ data }) => {
          for (const [value, text] of Object.entries(data)) {
            this.affiliates.push({ value: value, text: value + " - " + text });
          }
          this.affiliates.reverse();
        });
    }
  },
  created() {
    this.getAffiliates();
  },
  data() {
    return {
      affiliates: [],
      triggerEventOptions: [
        {
          value: 'SOI',
          text: "SOI -> Pay per Lead (CPL)"
        },
        {
          value: 'DOI',
          text: "DOI -> Pay per Lead (CPL)"
        },
        {
          value: 'erstem Kauf',
          text: "beim ersten Kauf (einmalig) -> Pay per Sale(CPO)"
        },
        {
          value: 'jedem Kauf',
          text: "bei jedem Kauf -> Pay per Sale(CPO)"
        },
        {
          value: 'Seitenbesuch',
          text: "nur Besuch"
        }
      ],
      typeOptions: [
        {
          value: 'HTTP',
          text: "S2S / Curl / HTTP(s) aufruf "
        },
        {
          value: 'HTML',
          text: "Tracking HTML/Javascript"
        }
      ]
    };
  },
  computed: {
    id() {
      return Number(this.$route.params.id);
    },
    original() {
      return this.$store.getters['postback/find'](this.id);
    },
    updateUrl() {
      return this.original !== undefined ? this.original.update_url : "";
    }
  }
}
</script>
